var t = function t(o) {
  return o === void 0 || o === "";
};

export { t as isEmpty };